import(/* webpackMode: "eager" */ "/app/src/app/[lang]/error.tsx");
